import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { Blog, Instructor } from '../../types/types';
export type BlogByIdDTO = Blog & {
    instructor?:Instructor
}

    type getBlogResponse = {
        statusCode?: number;
        error?: null | ApiError;
        data?: BlogByIdDTO;
      
    }
    export const GetBlogById = async (blogId: string): Promise<getBlogResponse> => {
        try {
            const response = await axios.get(`/blog/${blogId}`);
                    return { data: response.data };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            console.error("API Error:", error);
            if (error.response) {
                const apiError: ApiError = {
                    statusCode: error.response.status,
                    message: error.response.data.message,
                    error: error.response.data.error,
                };
                return { error: apiError };
            } else {
                const fallbackError: ApiError = {
                    statusCode: 500,
                    message: "An unexpected error occurred",
                };
                return { error: fallbackError };
            }
        }
    };
